import { Dialog } from "@mui/material";
import { useState } from "react";
import { IDataAnpGrupo } from "../../types/api/estoque/pesquisar-anp-grupo";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../BaseInputs/MultipleChipsField";

export default function SelectAnpGrupo({
                                           value,
                                           onChange,
                                           required = false,
                                           error = false,
                                           multiple = true,
                                       }: SelectAnpGrupoProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    return (
        <>
            <MultipleChipsField
                value={value}
                label="Grupos ANP"
                required={required}
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {openModal && (
                <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        multiple={multiple}
                        title="Selecionar grupo ANP"
                        queryPath="estoque/pesquisar-anp-grupo"
                        getItemKey={(item) => item?.id ?? 0}
                        getItemLabel={(item) => (item ? `${item.id} - ${item.nome}` : "")}
                        defaultValue={value ?? []}
                        onChange={(value) => {
                            onChange(value as IDataAnpGrupo[]);
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}

interface SelectAnpGrupoProps {
    value: IDataAnpGrupo[] | null;
    onChange: (arg: IDataAnpGrupo[] | null) => void;
    required?: boolean;
    error?: boolean;
    multiple?: boolean;
}